import { 
  Button,
  Typography, 
  InputNumber, 
  Card, 
  Switch, 
  Select,
} from "antd";
import { audioMessage as message } from '../../Common/Notifications/audioMessage';
import { ColorPickerWithLabel } from './ColorPickerWithLabel';
import React from "react";
import { useState } from "react";
import "../styles.css";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateTeamSettings,
  setModifiedSettings,
  setSettingsResponse
} from "../../../store/actions/settings.actions"
import { getTeamInfo } from "../../../store/actions/team.actions";
import { 
  PermissionedButton, 
  PermissionedInputNumber, 
  PermissionedSelect,
  PermissionedSwitch
} from "../../PermissionedComponents";

const { Text } = Typography;

export const OverviewSettings = () => {
  const dispatch = useDispatch();
  const [sample1TextColor, setSample1TextColor] = useState("black");
  const [sample1BGColor, setSample1BGColor] = useState("white");
  const [sample2TextColor, setSample2TextColor] = useState("black");
  const [sample2BGColor, setSample2BGColor] = useState("white");
  const [hideTopSpeedThreshold, setHideTopSpeedThreshold] = useState(false);

  const {
    info: teamInfo,
    metrics,
    misc: { user_permissions: userPermissions }
  } = useSelector(({ team }) => team);

  // Check if user has permission to edit general team settings
  const hasEditGeneralTeamSettingsPermission = userPermissions?.EditGeneralTeamSettings;

  const {
    loading: { teamSettings: loading },
    teamSettingsResponse,
    modifiedSettings: {
      teamColors,
      homeTimeZone,
      automaticOutlierApproval,
      playersAppPermission,
      preferredDateFormat,
      acwrLowerLimit,
      acwrUpperLimit,
      acwrAcuteWindow,
      acwrChronicWindow,
      topSpeedPercThreshold,
      chronicIncludesAcute
    },
    error
  } = useSelector(({ settings }) => settings);

  useEffect(()=> {
    dispatch(getTeamInfo());
    dispatch(setSettingsResponse(null));
  }, []);

  useEffect(()=> {
    if (metrics !== undefined && metrics.length > 0) {
      const topSpeedExists = metrics.some(metric => metric.key == "top_speed");
      setHideTopSpeedThreshold(!topSpeedExists);
    }
  }, [metrics]);

  useEffect(()=> {
    if (teamSettingsResponse !== null) {
      if (teamSettingsResponse) {
        setTeamSettings(teamSettingsResponse);
        message.success("Team Settings Updated Successfully");
      } else {
        message.error("Error Occurred While Updating Team Settings. Please Try Again Later.");
      }
      dispatch(setSettingsResponse(null));
    }
  }, [teamSettingsResponse]);

  const setTeamSettings = (teamInfo) => {
    if(teamInfo !== undefined && Object.keys(teamInfo).length > 0) {
      let defaultSettings = {};
      defaultSettings["gender"] = teamInfo.gender;
      defaultSettings["teamColors"] = teamInfo.team_colors || teamInfo.colors;
      defaultSettings["homeTimeZone"] = teamInfo.home_timezone;
      defaultSettings["automaticOutlierApproval"] = !teamInfo.auto_outlier_approval;
      defaultSettings["playersAppPermission"] = teamInfo.players_view_data_permission
      defaultSettings["preferredDateFormat"] = teamInfo.date_format;
      defaultSettings["acwrLowerLimit"] = teamInfo.acwr_lower_limit;
      defaultSettings["acwrUpperLimit"] = teamInfo.acwr_upper_limit;
      defaultSettings["topSpeedPercThreshold"] = teamInfo.top_speed_threshold;
      defaultSettings["acwrAcuteWindow"] = teamInfo.acwr_acute_window;
      defaultSettings["acwrChronicWindow"] = teamInfo.acwr_chronic_window;
      defaultSettings["chronicIncludesAcute"] = teamInfo.chronic_includes_acute;

      if (teamInfo?.team_colors !== undefined && Object.keys(teamInfo?.team_colors).length > 0) {
        if (Object.keys(teamInfo?.team_colors).includes("all")) {
          setSample1BGColor(teamInfo?.team_colors?.all[0]);
          setSample2BGColor(teamInfo?.team_colors?.all[1]);
        }
        
        if (Object.keys(teamInfo?.team_colors).includes("font_colors")) {
          setSample1TextColor(teamInfo?.team_colors?.font_colors[0]);
          setSample2TextColor(teamInfo?.team_colors?.font_colors[1]);
        }
      }
      
      dispatch(setModifiedSettings(defaultSettings));
    }
  }

  useEffect(() => {
    setTeamSettings(teamInfo)
  }, [teamInfo])


  const timezoneOptions = [
    {
      key: 1,
      value: 'US/Alaska',
      label: 'US/Alaska',
    },
    {
      key: 2,
      value: 'US/Hawaii',
      label: 'US/Hawaii',
    },
    {
      key: 3,
      value: 'US/Pacific',
      label: 'US/Pacific',
    },
    {
      key: 4,
      value: 'US/Mountain',
      label: 'US/Mountain',
    },
    {
      key: 5,
      value: 'US/Central',
      label: 'US/Central',
    },
    {
      key: 6,
      value: 'US/Eastern',
      label: 'US/Eastern',
    },
    {
      key: 7,
      value: 'America/Anchorage',
      label: 'America/Anchorage',
    },
    {
      key: 8,
      value: 'America/Los_Angeles',
      label: 'America/Los_Angeles',
    },
    {
      key: 9,
      value: 'America/Denver',
      label: 'America/Denver',
    },
    {
      key: 10,
      value: 'America/Chicago',
      label: 'America/Chicago',
    },
    {
      key: 11,
      value: 'America/New_York',
      label: 'America/New_York',
    },
  ];

  const playersAppPermissionsOptions = [
    {
      key: 1,
      value: 'view_own_data',
      label: 'View Own Data',
    },
    {
      key: 2,
      value: 'view_no_data',
      label: 'View No Data',
    },
    {
      key: 3,
      value: 'view_all_data',
      label: 'View All Data',
    }
  ];

  const dateFormatOptions = [
    {
      key: 1,
      value: 'MM/DD/YYYY',
      label: 'MM/DD/YYYY',
    },
    {
      key: 2,
      value: 'DD/MM/YYYY',
      label: 'DD/MM/YYYY',
    },
    {
      key: 5,
      value: 'MM/DD/YY',
      label: 'MM/DD/YY',
    },
    {
      key: 6,
      value: 'YYYY/MM/DD',
      label: 'YYYY/MM/DD',
    },
    {
      key: 3,
      value: 'DD-MM-YYYY HH:MM:SS',
      label: 'DD-MM-YYYY HH:MM:SS',
    },
    {
      key: 4,
      value: 'MM/DD/YYYY HH:MM:SS pp',
      label: 'MM/DD/YYYY HH:MM:SS pp',
    },
    {
      key: 4,
      value: 'YYYY/MM/DDTHH:MM:SSZ',
      label: 'YYYY/MM/DDTHH:MM:SSZ',
    },
    {
      key: 7,
      value: 'int',
      label: 'Integer',
    }
  ];

  const handleColorChange = (pickerId, hexColorStr) => {
    // Check permission before allowing color changes
    if (!hasEditGeneralTeamSettingsPermission) {
      return;
    }
    
    const newTeamColors = {...teamColors};
    if (pickerId.startsWith("team-color-")) {
      const index = parseInt(pickerId.slice(-1)) - 1;
      newTeamColors["all"][index] = hexColorStr;

      if (index === 0) {
        newTeamColors["primary"] = hexColorStr;
        setSample1BGColor(hexColorStr);
      } else if (index === 1) {
        newTeamColors["secondary"] = hexColorStr;
        setSample2BGColor(hexColorStr);
      }
    } else if (pickerId.startsWith("font-color-")) {
      const index = parseInt(pickerId.slice(-1)) - 1;
      newTeamColors["font_colors"][index] = hexColorStr;

      if (index === 0) {
        setSample1TextColor(hexColorStr);
      } else if (index === 1) {
        setSample2TextColor(hexColorStr);
      }
    }
    dispatch(setModifiedSettings({teamColors: newTeamColors}))
  }

  const handleSave = () => {
    dispatch(updateTeamSettings());
  }

  const handleHomeTimezoneChange = (homeTimeZone) => {
    dispatch(setModifiedSettings({ homeTimeZone }));
  }

  const handleAutoOutlierApprovalChange = (automaticOutlierApproval) => {
    dispatch(setModifiedSettings({automaticOutlierApproval}));
  }

  const handleChronicIncludesAcuteChange = (chronicIncludesAcute) => {
    dispatch(setModifiedSettings({chronicIncludesAcute}));
  }

  const handlePlayersAppPermissionChange = (playersAppPermission) => {
    dispatch(setModifiedSettings({playersAppPermission}));
  }

  const handlePreferredDateFormatChange = (preferredDateFormat) => {
    dispatch(setModifiedSettings({preferredDateFormat}));
  }

  const handleTopSpeedPercThresholdChange = (topSpeedPercThreshold) => {
    dispatch(setModifiedSettings({topSpeedPercThreshold}));
  }

  const handleACWRLowerLimitChange = (acwrLowerLimit) => {
    if (acwrLowerLimit > acwrUpperLimit) {
      message.error("ACWR lower limit should be less than upper limit");
    } else {
      dispatch(setModifiedSettings({acwrLowerLimit}));
    }
  }

  const handleACWRUpperLimitChange = (acwrUpperLimit) => {
    if (acwrUpperLimit < acwrLowerLimit) {
      message.error("ACWR upper limit should be greater than lower limit");
    } else {
      dispatch(setModifiedSettings({acwrUpperLimit}));
    }
  }

  const handleACWRAcuteWindowChange = (acwrAcuteWindow) => {
    if (acwrAcuteWindow > acwrChronicWindow) {
      message.error("ACWR acute window should be less than chronic window");
    } else {
      dispatch(setModifiedSettings({acwrAcuteWindow}));
    }
  }

  const handleACWRChronicWindowChange = (acwrChronicWindow) => {
    if (acwrChronicWindow < acwrAcuteWindow) {
      message.error("ACWR acute window should be less than chronic window");
    } else {
      dispatch(setModifiedSettings({acwrChronicWindow}));
    }
  }

  return (
    <div className="general-overview-settings">
      <PermissionedButton
        type="primary"
        onClick={handleSave}
        loading={loading}
        permissionCheck="EditGeneralTeamSettings"
      >
        Save Changes
      </PermissionedButton>
      <br></br>
      <Card className="settings-card team-colors-card">
        <div className="team-color-pickers">
          <div><strong>Team Colors</strong></div>
          <div className="picker-selection-info">
            <div className="team-color-picker-div">
              {
                teamColors && teamColors?.all && (
                  teamColors?.all.map((color, index) => {
                    const tertiaryIdx = (index - 2) + 1;
                    if (tertiaryIdx < 4) {
                      return (
                        <ColorPickerWithLabel 
                          key={`team-color-${index}`}
                          pickerId={`team-color-${index + 1}`}
                          handleColorChangeParent={handleColorChange}
                          defaultColor={color}
                          defaultText={
                            index === 0 ? "Primary" : (index === 1 ? "Secondary": `Tertiary ${tertiaryIdx}`)
                          }
                        />
                      )
                    } else {
                      return <></>
                    }
                  })
                )
              }
            </div>
          </div>
          <div className="font-colors-div">
            {
              teamColors && teamColors?.font_colors && (
                teamColors?.font_colors.map((color, index) => (
                  <ColorPickerWithLabel 
                    key={`font-color-${index}`}
                    pickerId={`font-color-${index + 1}`}
                    handleColorChangeParent={handleColorChange}
                    defaultColor={color}
                    defaultText={
                      index === 0 ? "Font 1" : (index === 1 ? "Font 2": null)
                    }
                    className="font-color-picker-div"
                  />
                ))
              )
            }
          </div>
          <div className="sample-text-div">
            <div 
              className="sample-text primary-text"
              style={{
                      color: sample1TextColor , 
                      backgroundColor: sample1BGColor,
                      borderColor: sample1BGColor
                    }}
            >
              Sample Text
            </div>
            <div 
              className="sample-text secondary-text"
              style={{
                      color: sample2TextColor, 
                      backgroundColor: sample2BGColor,
                      borderColor: sample2BGColor
                    }}
            >
              Sample Text
            </div>
            <div 
              className="sample-text secondary-text"
              style={{
                      color: '#d9534f', 
                      backgroundColor: sample2BGColor,
                      borderColor: sample2BGColor
                    }}
            >
              <b>Sample Text</b>
            </div>
            <div 
              className="sample-text secondary-text"
              style={{
                      color: '#FFC83D', 
                      backgroundColor: sample2BGColor,
                      borderColor: sample2BGColor
                    }}
            >
              <b>Sample Text</b>
            </div>
            <div 
              className="sample-text secondary-text"
              style={{
                      color: '#31B452', 
                      backgroundColor: sample2BGColor,
                      borderColor: sample2BGColor
                    }}
            >
              <b>Sample Text</b>
            </div>
          </div>
          <div className="desc-div">
            <Text 
              disabled
              className="description"
            >
              Choose your signature colors. These colors will be used in your custom reports.
            </Text>
          </div>
        </div>
      </Card>
      {/* <Card className="settings-card timezone-card">
        <div>
          <strong>Home Time zone</strong>
          <Select
            className="select-dd timezone-select"
            value={homeTimeZone}
            showSearch
            style={{
              width: 200,
            }}
            placeholder="Search to Select"
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
            onChange={handleHomeTimezoneChange}
            options={timezoneOptions}
          />
        </div>
      </Card> */}
      <Card className="settings-card outlier-approval-card">
        <strong>Ask me before skipping outliers?</strong>
        <PermissionedSwitch 
          checked={automaticOutlierApproval}
          className="outlier-approval-switch"
          onChange={handleAutoOutlierApprovalChange}
          permissionCheck="EditGeneralTeamSettings"
        />
        <br></br>
        <br></br>
        <Text 
          disabled
          className="description"
        >
          <ul>
            <li>If enabled, you will be prompted to approve/reject detected outliers in the data during uploads.</li>
            <li>If disabled, our custom algorithm will automatically detect and disacrd outliers.</li>
          </ul>
        </Text>
      </Card>
      <Card className="settings-card app-permission-card">
        <div>
          <strong>Player's App Permissions</strong>
          <PermissionedSelect
            className="select-dd app-permission-select"
            showSearch
            style={{
              width: 200,
            }}
            placeholder="Search to Select"
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
            value={playersAppPermission}
            options={playersAppPermissionsOptions}
            onChange={handlePlayersAppPermissionChange}
            permissionCheck="EditGeneralTeamSettings"
          />
        </div>
        <br></br>
        <Text 
          disabled
          className="description"
        >
          Select what level of data access you want to give your players on the GPS DataViz app.
        </Text>
      </Card>
      {/* <Card className="settings-card date-format-card">
        <div>
          <strong>Source Date Format</strong>
          <Select
            className="select-dd date-format-select"
            showSearch
            style={{
              width: 250,
            }}
            placeholder="Search to Select"
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
            value={preferredDateFormat}
            options={dateFormatOptions}
            onChange={handlePreferredDateFormatChange}
          />
        </div>
        <br></br>
        <Text 
          disabled
          className="description"
        >
          This is the format of the source data, either from an uploaded file or an API. 
        </Text>
      </Card> */}
      <Card className="settings-card">
        <div className="acwr-limits-card">
          <strong>ACWR Limits</strong>
          <div className="acwr-limits">
            <div>
              <strong>Lower</strong>
              <PermissionedInputNumber 
                placeholder="Ex: 0.8" 
                value={acwrLowerLimit} 
                min={0}
                max={3}
                step={0.1}
                className="ip acwr-limit-ip"
                onChange={handleACWRLowerLimitChange}
                permissionCheck="EditGeneralTeamSettings"
              />
            </div>
            <div className="upper-limit">
              <strong>Upper</strong>
              <PermissionedInputNumber 
                placeholder="Ex: 1.3" 
                value={acwrUpperLimit} 
                min={0}
                max={3}
                step={0.1}
                className="ip acwr-limit-ip"
                onChange={handleACWRUpperLimitChange}
                permissionCheck="EditGeneralTeamSettings"
              />
            </div>
          </div>
        </div>
        <br></br>
        <Text 
          disabled
          className="description"
        >
          These thresholds are used to determine if a player is overworked or underworked. 
        </Text>
      </Card>
      <Card className="settings-card">
        <div className="acwr-window-card">
          <strong>ACWR Windows</strong>
          <div className="chronic-includes-acute-div">
            <strong>Chronic Includes Acute?</strong>
            <PermissionedSwitch 
              checked={chronicIncludesAcute}
              className="chronic-includes-acute-switch"
              onChange={handleChronicIncludesAcuteChange}
              permissionCheck="EditGeneralTeamSettings"
            />  
          </div>
          <div className="acute-chronic-windows">
            <div>
              <strong>Acute</strong>
              <PermissionedInputNumber 
                placeholder="Ex: 7.0" 
                value={acwrAcuteWindow} 
                min={1}
                max={60}
                step={0.1}
                className="ip acwr-limit-ip"
                onChange={handleACWRAcuteWindowChange}
                permissionCheck="EditGeneralTeamSettings"
              />
            </div>
            <div className="chronic-window">
              <strong>Chronic</strong>
              <PermissionedInputNumber 
                placeholder="Ex: 21.0" 
                value={acwrChronicWindow} 
                min={1}
                max={60}
                step={0.1}
                className="ip acwr-limit-ip"
                onChange={handleACWRChronicWindowChange}
                permissionCheck="EditGeneralTeamSettings"
              />
            </div>
          </div>
        </div>
        <br></br>
        <Text 
          disabled
          className="description"
        >
          The Acute and Chronic windows are used to calculate the ACWR ratio for your metrics. These ratios are used to determine if a player is overworked or underworked.
        </Text>
      </Card>
      {
        !hideTopSpeedThreshold && (
          <Card className="settings-card top-speed-threshold-card">
            <div>
              <strong>Top Speed Percent Threshold</strong>
              <PermissionedInputNumber 
                placeholder="Ex: 85" 
                value={topSpeedPercThreshold} 
                min={0}
                max={100}
                step={1}
                className="ip top-speed-threshold-ip"
                onChange={handleTopSpeedPercThresholdChange}
                permissionCheck="EditGeneralTeamSettings"
              />
            </div>
            <br></br>
            <Text 
              disabled
              className="description"
            >
              This threshold is used to provide custom insights on the platform and reports. 
            </Text>
          </Card>
        )
      }
      <br></br>
      <br></br>
      <PermissionedButton
        type="primary"
        onClick={handleSave}
        loading={loading}
        permissionCheck="EditGeneralTeamSettings"
      >
        Save Changes
      </PermissionedButton>
    </div>
  );
};
